module.exports = __webpack_public_path__ + "4c39779744a48ff86b1f2d7bc1286ce5.png";